
export class ReportUserRequestDto {
  reportReason: string;
}
